import { render, staticRenderFns } from "./block-profile-socials.vue?vue&type=template&id=531cf414&scoped=true&lang=pug"
import script from "./block-profile-socials.vue?vue&type=script&lang=js"
export * from "./block-profile-socials.vue?vue&type=script&lang=js"
import style0 from "./block-profile-socials.vue?vue&type=style&index=0&id=531cf414&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531cf414",
  null
  
)

export default component.exports